import { useContext } from 'react'
import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { CvsAutoComplete } from '@components'
import { formatSelectedOptions } from '@components/select/cvs-autocomplete'
import { useIntegrationAssignment } from '@global/hooks'
import { templateCopyContext } from '../../../../context'

const NoMarginTypography = styled(Typography)`
  margin-top: 0px;
`
const TypographyBold = styled(Typography)`
  weight: 500;
`
const GridMargin = styled(Grid)`
  margin-top: 0;
  margin-bottom: 16px;
  flex-direction: column;
`

interface Option {
  value: string
  label: string
}

interface DropDownProps {
  title: string
  desription?: string
  selected: string | string[] | null
  integrationAssignment: any
  options: Option[]
  metadataKey: string
  label: string
  waitingOnDependancy?: boolean
  dependancyTitle?: string
  isLoading?: boolean
  isMulti?: boolean
}

export const DropDown = ({
  selected,
  integrationAssignment,
  options,
  metadataKey,
  title,
  desription,
  label,
  waitingOnDependancy,
  dependancyTitle,
  isLoading,
  isMulti,
}: DropDownProps) => {
  const { onChange } = useContext<any>(templateCopyContext)
  const { onIntegrationMetadataChange } = useIntegrationAssignment({
    integrationAssignment,
    onChange,
  })

  const handleSelected = (value: string | string[]) => {
    onIntegrationMetadataChange(value, metadataKey)
  }

  const errorMessage = !waitingOnDependancy && !selected ? t`Required` : null

  return (
    <GridMargin container>
      <FormControl fullWidth>
        <TypographyBold variant="h4">{title}</TypographyBold>
        {desription && <NoMarginTypography variant="body2">{desription}</NoMarginTypography>}
        {waitingOnDependancy && dependancyTitle ? (
          <Tooltip
            title={t`Before selecting this field, please select a field for the ${dependancyTitle} section`}
            placement="top-start"
          >
            <span>
              <CvsAutoComplete
                disabled={waitingOnDependancy}
                isLoading={isLoading}
                isMulti={isMulti}
                margin="dense"
                options={options as any}
                label={label}
                selected={formatSelectedOptions(isMulti, selected, options)?.value}
                onSelected={handleSelected}
                error={errorMessage ?? undefined}
              />
            </span>
          </Tooltip>
        ) : (
          <CvsAutoComplete
            disabled={waitingOnDependancy}
            isLoading={isLoading}
            isMulti={isMulti}
            margin="dense"
            options={options as any}
            label={label}
            selected={formatSelectedOptions(isMulti, selected, options)?.value}
            onSelected={handleSelected}
            error={errorMessage ?? undefined}
          />
        )}
      </FormControl>
    </GridMargin>
  )
}
